import { Button, Label, TextInput, useValidatedState } from "acma-spa";
import React, { useEffect } from "react";
import { IInvoice, Invoice } from "../api";
import * as yup from "yup";

export interface InvoiceDetailsProps {
  r: Invoice | null;
  errors: string;
  onChange: (r: IInvoice | null) => void;
  disabled: boolean;
}

export const InvoiceDetails: React.FC<InvoiceDetailsProps> = (props): any => {
  const invoiceSchema: yup.ObjectSchema<IInvoice> = yup.object({
    invoiceNumber: yup.string().min(9).label("Invoice Number").nullable(),
    paid: yup.bool(),
    outstandingAmount: yup.number(),
  });

  let blank = Invoice.fromJS({ invoiceNumber: null, amount: 0 });
  const [invoice, setInvoice, errors, validate] = useValidatedState<IInvoice>(
    props.r || blank,
    invoiceSchema
  );

  const handleAdd = async () => {
    if (invoice.invoiceNumber === null) {
      invoice.invoiceNumber = "";
    }
    await validate("#container").then(async (result) => {
      if (result) {
        props.onChange(invoice);
        setInvoice(blank);
      }
    });
  };

  return (
    <>
      <div id="container">
        <Label
          label="What is your invoice or renewal notice number?"
          id="number"
          className="mb-3"
          error={errors.invoiceNumber || props.errors}
        >
          <TextInput
            value={invoice.invoiceNumber ?? ""}
            placeholder="Enter your 9-digit notice number here"
            onChange={(v) => setInvoice({ invoiceNumber: v })}
            size={"block"}
            maxLength={9}
          />
        </Label>
        <div className="d-flex">
          <Button
            disabled={props.disabled}
            label={props.r ? "Update" : "Add notice/invoice"}
            onClick={() => handleAdd()}
          />
        </div>
      </div>
    </>
  );
};
